import type { TerminalSessionSnapshot } from "@cmmd-forge/contracts";
import type { Terminal } from "@xterm/xterm";
import type { RefObject } from "react";

export function writeTerminalSystemMessage(terminal: Terminal, message: string): void {
  terminal.write(`\r\n[terminal] ${message}\r\n`);
}

export function writeTerminalSnapshot(terminal: Terminal, snapshot: TerminalSessionSnapshot): void {
  terminal.write("\u001bc");
  if (snapshot.history.length > 0) terminal.write(snapshot.history);
}

export function TerminalViewportContainer(props: {
  readonly containerRef: RefObject<HTMLDivElement | null>;
  readonly error: string | null;
}) {
  return (
    <div
      ref={props.containerRef}
      className="relative h-full w-full overflow-hidden rounded-[4px] bg-background"
    >
      {props.error ? (
        <div className="flex h-full items-center justify-center px-4 text-center text-sm text-muted-foreground">
          {props.error}
        </div>
      ) : null}
    </div>
  );
}
